"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscriptions = void 0;
const core = __importStar(require("../../../../../../core"));
const Platform = __importStar(require("../../../../../index"));
const url_join_1 = __importDefault(require("url-join"));
const serializers = __importStar(require("../../../../../../serialization/index"));
const errors = __importStar(require("../../../../../../errors/index"));
class Subscriptions {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Handles the creation of a Stripe setup intent based on the payment method type.
     *
     * @param {Platform.payment.SubscriptionsStripeSetupIntentRequest} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.stripeSetupIntent()
     */
    stripeSetupIntent() {
        return __awaiter(this, arguments, void 0, function* (request = {}, requestOptions) {
            var _a;
            const { paymentMethodType } = request;
            const _queryParams = {};
            if (paymentMethodType != null) {
                _queryParams["paymentMethodType"] = paymentMethodType;
            }
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/stripe-setup-intent"),
                method: "GET",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                queryParameters: _queryParams,
                requestType: "json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.StripeSetupIntentResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling GET /subscriptions/stripe-setup-intent.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     *
     * Initiates the creation of a new Stripe subscription.
     * It validates user information, checks for existing active subscriptions, and applies any specified coupon codes.
     * If the subscription is part of a migration from the App Store, it handles billing cycle anchor and proration behavior.
     * It also deals with trial periods and ensures that no active overlapping subscriptions exist.
     * Finally, it resolves the payment method and creates the subscription through Stripe.
     *
     * @param {Platform.payment.CreateSubscriptionDto} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.subscribe({
     *         userId: "userId",
     *         paymentMethodId: "paymentMethodId"
     *     })
     */
    subscribe(request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.payment.CreateSubscriptionDto.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.StripeSubscriptionResponseDto.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Updates the plan of the provided subscription with a new one
     *
     * @param {Platform.payment.ChangeSubscriptionPlanDto} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.changeSubscriptionPlan({
     *         subscriptionId: "subscriptionId",
     *         planId: "planId"
     *     })
     */
    changeSubscriptionPlan(request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/stripe/change-subscription-plan"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.payment.ChangeSubscriptionPlanDto.jsonOrThrow(request, {
                    unrecognizedObjectKeys: "strip",
                }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.GenericStatusResponseDto.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions/stripe/change-subscription-plan.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Fetches the balance transactions for the current user which contain the amount, currency, type, etc. related to each transaction
     *
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.listCustomerBalanceTransactions()
     */
    listCustomerBalanceTransactions(requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/stripe/customer-balance-transactions"),
                method: "GET",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.ListCustomerBalanceTransactionsDto.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling GET /subscriptions/stripe/customer-balance-transactions.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Fetches the upcoming discount for the subscription specified
     *
     * @param {Platform.payment.UpcomingDiscountDto} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.retrieveUpcomingDiscount({
     *         subscriptionId: "subscriptionId"
     *     })
     */
    retrieveUpcomingDiscount(request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/stripe/upcoming-discount"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.payment.UpcomingDiscountDto.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.UpcomingDiscountResponseDto.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions/stripe/upcoming-discount.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Validates the card country for the subscription.
     *
     * @param {Platform.payment.ValidateCardCountryDto} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Platform.payment.BadRequestError}
     * @throws {@link Platform.payment.InternalServerError}
     *
     * @example
     *     await client.payment.subscriptions.validateCardCountry({
     *         paymentMethodId: "paymentMethodId",
     *         subscriptionCurrency: "subscriptionCurrency"
     *     })
     */
    validateCardCountry(request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/stripe/validate-card-country"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.payment.ValidateCardCountryDto.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.ValidateCardCountryResponseDto.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Platform.payment.BadRequestError(_response.error.body);
                    case 500:
                        throw new Platform.payment.InternalServerError(_response.error.body);
                    default:
                        throw new errors.PlatformError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions/stripe/validate-card-country.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     *
     * Creates a payment intent that can be fulfilled by the client.
     * The function also allows creating holds that will be auto released when trial gets cancelled or before the conversion through webhooks
     *
     * @param {Platform.payment.RequestTrialByAmountDto} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Platform.payment.BadRequestError}
     * @throws {@link Platform.payment.UnprocessableEntityError}
     * @throws {@link Platform.payment.InternalServerError}
     *
     * @example
     *     await client.payment.subscriptions.requestTrialByAmount({
     *         paymentMethodId: "paymentMethodId",
     *         planId: "planId",
     *         userId: "userId",
     *         subscriptionCurrency: "subscriptionCurrency",
     *         referral: "referral",
     *         captureMethod: "automatic",
     *         shouldAutoReleaseHold: true
     *     })
     */
    requestTrialByAmount(request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/stripe/request-trial-by-amount"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.payment.RequestTrialByAmountDto.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.RequestTrialByAmountResult.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Platform.payment.BadRequestError(_response.error.body);
                    case 422:
                        throw new Platform.payment.UnprocessableEntityError(_response.error.body);
                    case 500:
                        throw new Platform.payment.InternalServerError(_response.error.body);
                    default:
                        throw new errors.PlatformError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions/stripe/request-trial-by-amount.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Skips the trial of the current subscription for the authorized user
     *
     * @param {Platform.payment.SkipTrialDto} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.skipTrial()
     */
    skipTrial() {
        return __awaiter(this, arguments, void 0, function* (request = {}, requestOptions) {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/skip-trial"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.payment.SkipTrialDto.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.StripeSubscriptionResponseDto.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions/skip-trial.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Cancels all existing subscriptions for the current user
     *
     * @param {Platform.payment.SubscriptionCancellationDto} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.cancelSubscription({})
     */
    cancelSubscription(request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/cancelSubscription"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.payment.SubscriptionCancellationDto.jsonOrThrow(request, {
                    unrecognizedObjectKeys: "strip",
                }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return;
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions/cancelSubscription.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Reactivate subscription for the current user
     *
     * @param {string} subscriptionId
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.reactivateSubscription("subscriptionId")
     */
    reactivateSubscription(subscriptionId, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, `subscriptions/${encodeURIComponent(subscriptionId)}/reactivate`),
                method: "PATCH",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return;
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling PATCH /subscriptions/{subscriptionId}/reactivate.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Prepares a new PayPal subscription and returns the subscription id.
     *
     * @param {Platform.payment.PayPalPrepareSubscriptionDto} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.preparePayPalSubscription({
     *         planId: "planId"
     *     })
     */
    preparePayPalSubscription(request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/paypal/prepareSubscription"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.payment.PayPalPrepareSubscriptionDto.jsonOrThrow(request, {
                    unrecognizedObjectKeys: "strip",
                }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.PaypalPrepareSubscriptionResponseDto.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions/paypal/prepareSubscription.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Subscribes a user using PayPal, handles subscription creation, verification, activation, and cancellation.
     *
     * @param {Platform.payment.PaypalCreateSubscriptionDto} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.subscribeUsingPaypal({
     *         userId: "userId",
     *         subscriptionId: "subscriptionId"
     *     })
     */
    subscribeUsingPaypal(request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/paypal"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.payment.PaypalCreateSubscriptionDto.jsonOrThrow(request, {
                    unrecognizedObjectKeys: "strip",
                }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.GenericStatusResponseDto.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions/paypal.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Creates a new subscription using PlayStore
     *
     * @param {Platform.payment.PlayStoreCreateSubscriptionDto} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.subscribeUsingPlayStore({
     *         purchaseToken: "purchaseToken",
     *         userId: "userId"
     *     })
     */
    subscribeUsingPlayStore(request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/playstore"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.payment.PlayStoreCreateSubscriptionDto.jsonOrThrow(request, {
                    unrecognizedObjectKeys: "strip",
                }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.GenericStatusResponseDto.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions/playstore.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Apply discount to subscription on next cycle
     *
     * @param {Platform.payment.ApplyDiscountDto} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.applyDiscountToSubscription({
     *         subscriptionId: "subscriptionId",
     *         promoCode: "promoCode"
     *     })
     */
    applyDiscountToSubscription(request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/apply-discount"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.payment.ApplyDiscountDto.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.GenericStatusResponseDto.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions/apply-discount.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Extends the trial of a subscription
     *
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.extendTrial()
     */
    extendTrial(requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/extend-trial"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.ExtendTrialResultDto.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions/extend-trial.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * @param {Platform.payment.PlayStoreCreateSubscriptionDto} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.migratePlayStoreSubscription({
     *         purchaseToken: "purchaseToken",
     *         userId: "userId"
     *     })
     */
    migratePlayStoreSubscription(request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/migratePlayStoreSubscription"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.payment.PlayStoreCreateSubscriptionDto.jsonOrThrow(request, {
                    unrecognizedObjectKeys: "strip",
                }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return;
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions/migratePlayStoreSubscription.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Returns all the subscriptions and entitlements for the authorized user
     *
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.getAllSubscriptions()
     */
    getAllSubscriptions(requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/getAllSubscriptionsAndEntitlements"),
                method: "GET",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.payment.MultiSubscriptionAndEntitlementsResponseDto.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling GET /subscriptions/getAllSubscriptionsAndEntitlements.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Cancels a subscription for the current user
     *
     * @param {Platform.payment.SubscriptionCancellationDto} request
     * @param {Subscriptions.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.payment.subscriptions.cancelUnpaidSubscriptionInternal({})
     */
    cancelUnpaidSubscriptionInternal(request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.baseUrl))) !== null && _a !== void 0 ? _a : (yield core.Supplier.get(this._options.environment)).payment, "subscriptions/internal/stripe/cancelUnpaidSubscription"),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "x-caller": yield core.Supplier.get(this._options.caller), "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@speechifyinc/platform-public", "X-Fern-SDK-Version": "0.14.0", "User-Agent": "@speechifyinc/platform-public/0.14.0", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.payment.SubscriptionCancellationDto.jsonOrThrow(request, {
                    unrecognizedObjectKeys: "strip",
                }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return;
            }
            if (_response.error.reason === "status-code") {
                throw new errors.PlatformError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.PlatformError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.PlatformTimeoutError("Timeout exceeded when calling POST /subscriptions/internal/stripe/cancelUnpaidSubscription.");
                case "unknown":
                    throw new errors.PlatformError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter(this, void 0, void 0, function* () {
            const bearer = yield core.Supplier.get(this._options.token);
            if (bearer != null) {
                return `Bearer ${bearer}`;
            }
            return undefined;
        });
    }
}
exports.Subscriptions = Subscriptions;
